"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M6 7a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.33 6.15C5.33 4.344 6.93 3 8.75 3c1.817 0 3.418 1.344 3.418 3.15v5.95c0 .544-.184 1.072-.557 1.47-.378.405-.912.633-1.52.636-.614.002-1.15-.225-1.53-.633-.373-.4-.555-.93-.555-1.473V6.5a.7.7 0 1 1 1.4 0v5.6c0 .236.078.41.179.519.095.102.249.188.5.187.25-.001.406-.088.504-.192a.74.74 0 0 0 .179-.514V6.15c0-.9-.833-1.75-2.018-1.75s-2.02.85-2.02 1.75v6.65c0 1.466 1.379 2.8 3.27 2.8 1.89 0 3.27-1.334 3.27-2.8V6.5a.7.7 0 1 1 1.4 0v6.3c0 2.4-2.177 4.2-4.67 4.2s-4.67-1.8-4.67-4.2z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AttachFileIcon20.js.map